import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './businessManagement.module.css'
import { DetailModal } from './detailModal'
import { ApprovalFormModal } from './approvalFormModal'
import { printBodyBusiness } from '../../../models/approvalFormModalPrint'
import { GoForReviewModal } from '../goForReviewModal'
import {
  getBusinessListExportAsync,
  getBusinessManagementDetailAsync,
  getBusinessManagementListAsync,
  getFirstsellcompanyrecordBaseDeleteAsync,
} from './businessManagementSlice'
import { getDetailAsync } from '../varietyManagement/varietyManagementSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'

export const BusinessManagementList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [isEdit, setIsEdit] = useState<any>()

  const [editTenantId, setEditTenantId] = useState<any>()

  const [fscrId, setFscrid] = useState<any>()

  const [acceptType, setAcceptType] = useState<any>()

  const [exportLoading, setExportLoading] = useState<any>(false)

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
    startTime: null,
    endTime: null,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [
    isGoForReviewModalVisible,
    setIsGoForReviewModalVisible,
  ] = useState<any>()
  const [
    isApprovalFormModalVisible,
    setIsApprovalFormModalVisible,
  ] = useState<any>()

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getBusinessManagementListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '0') {
      if (!queries.current) return
      getDataList()
    }
  }, [queries, props?.selectKey])

  const dataMain = {}

  const content = printBodyBusiness(dataMain)

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getBusinessListExportAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '首营企业管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const getDetail = (fsrid: any, tenantId?: any) => {
    dispatch(
      getBusinessManagementDetailAsync({
        fscrId: fsrid,
        tenantId: tenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        // 打印
        const dataMain = {
          ...v,
        }
        const content = printBodyBusiness(dataMain)
        const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
        page.document.write(content) // 写入打印页面的内容
        page.print() // 打印
        page?.close()
      })
  }

  return (
    <Col className={styles.businessManagementContent}>
      <Col
        className={styles.businessManagementContentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          exportLoading={exportLoading}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v })
          }}
          export={() => {
            exportExcel()
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((text, t, acceptType) => {
            if (text === 'lookDetail') {
              setIsModalVisible(true)
              setFscrid(t?.id)
              setEditTenantId(t?.tenantId)
            } else if (text == 'print') {
              getDetail(t?.id, t?.tenantId)
            } else if (text == 'edit') {
              setIsApprovalFormModalVisible(true)
              setFscrid(t?.id)
              setIsEdit(t?.isEdit)
              setEditTenantId(t?.tenantId)
            } else if (text == 'goForReview') {
              setIsGoForReviewModalVisible(true)
              setAcceptType(acceptType)
              setId(t?.id)
            } else if (text == 'delete') {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认删除？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(getFirstsellcompanyrecordBaseDeleteAsync(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '删除成功',
                      })
                      getDataList()
                    })
                },
              })
            }
          }, (queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setFscrid(r.id)
            },
          })}
        />
      </Col>
      {/* 详情 */}
      <DetailModal
        editTenantId={editTenantId}
        isModalVisible={isModalVisible}
        fscrId={fscrId}
        onCancel={() => {
          setIsModalVisible(false)
          setFscrid('')
          setEditTenantId('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setFscrid('')
          setEditTenantId('')
          getDataList()
        }}
      />
      {/* 编辑 */}
      <ApprovalFormModal
        editTenantId={editTenantId}
        isEdit={isEdit}
        fscrId={fscrId}
        isModalVisible={isApprovalFormModalVisible}
        onCancel={() => {
          setIsApprovalFormModalVisible(false)
          setFscrid('')
          setIsEdit('')
          setEditTenantId('')
        }}
        onOk={() => {
          setIsApprovalFormModalVisible(false)
          setFscrid('')
          getDataList()
          setIsEdit('')
          setEditTenantId('')
        }}
      />
      {/* 去审核 */}
      <GoForReviewModal
        selectKey={props?.selectKey}
        id={id}
        acceptType={acceptType}
        visible={isGoForReviewModalVisible}
        onOk={() => {
          setIsGoForReviewModalVisible(false)
          setAcceptType('')
          setId('')
          getDataList()
        }}
        onCancel={() => {
          setIsGoForReviewModalVisible(false)
          setAcceptType('')
          setId('')
        }}
      />
    </Col>
  )
}
